import { createIsomorphicFn } from "@tanstack/react-start";
import { notFound } from "@tanstack/react-router";
import { readContentPage, readContentTree } from "./server";
import type { ContentPageData } from "./server";

async function readJson<T>(url: string): Promise<T> {
  const response = await fetch(url);
  if (response.status === 404) throw notFound();
  if (!response.ok) throw new Error("Unable to load content");
  return response.json();
}

// Public, read-only URLs avoid putting content behind the product's maintenance
// gate for authenticated server functions. SSR reads the source directly.
export const getContentPage = createIsomorphicFn()
  .server(readContentPage)
  .client((slugs: string[]) =>
    readJson<ContentPageData>(`/api/content/pages/${slugs.map(encodeURIComponent).join("/")}`),
  );

export const getContentTree = createIsomorphicFn()
  .server(readContentTree)
  .client(() => readJson<Awaited<ReturnType<typeof readContentTree>>>("/api/content/tree"));
